import { VectorLayerData } from "../components/vector_component"

const source: string = 'ind:long_combinedv2'

const crops: string[] = [
    'ARABICA COFFEE',
    'ARECA NUT',
    'CANDLE NUT',
    'CASHEWNUT',
    'CASSIAVERA',
    'CASTOR OIL SEEDS',
    'CITRONELLA',
    'CLOVE',
    'COCOA',
    'COCONUT',
    'COFFEE',
    'COTTON',
    'FAN PALM',
    'HYBRID COCONUT',
    'KAPOK',
    'NIPA PALM',
    'NUTMEG',
    'OIL PALM',
    'PATCHOULI',
    'PEPPER',
    'ROBUSTA COFFEE',
    'ROSELLA',
    'RUBBER',
    'SAGOO',
    'SUGAR CANE',
    'SUGAR COCONUT',
    'SUGAR PALM',
    'TALL COCONUT',
    'TAMARIND',
    'TEA',
    'TOBACCO',
    'VANILLA',
    'CASSAVA',
    'DRYLAND PADDY',
    'MAIZE',
    'MUNGBEANS',
    'PADDY',
    'PEANUTS',
    'SOYBEANS',
    'SWEET POTATOES',
    'WETLAND PADDY',
]

const yearFrom: number = 2000
const yearTo: number = 2020
const years: number[] = Array.from({ length: yearTo - yearFrom + 1 }, (_, i) => yearFrom + i)

const layers: VectorLayerData[] = []

years.forEach(year => {
    crops.forEach(crop => { 
        ['Yield', 'Production', 'Area'].forEach(indicator => {
            layers.push({
            name: `${crop} ${indicator} ${year} ${indicator === 'Yield' ? '[[t/ha]]' : indicator === 'Production' ? '[[t]]' : '[[ha]]'}`,
            source: [source],
            key: `value`,
            output: 'NumericTileGrid',
            distributed: false,
            wms: false,
            groups: [crop, indicator, year.toString()],
            cql: `crop = '${crop}' AND metric = '${indicator.toLowerCase()}' AND year = ${year}`,
            transform: indicator === 'Yield' && crop !== 'NUTMEG' ? (val: number) => val * 0.1 : undefined,
            properties: indicator === 'Yield' ? {
                unit: 't',
                area: 'ha',
                type: undefined
            } : indicator === 'Production' ? {
                unit: 't',
                area: undefined,
                type: undefined
            } : {
                unit: 'ha',
                area: undefined,
                type: undefined
            }
        })})
    })
})

export const GorontaloCrops2Properties: VectorLayerData[] = layers